import { useEffect, useRef } from 'react';

const LOGO_VIDEO_SRC = '/videos/hxd-logo-hero.mp4';
const PLAY_DELAY_MS = 1000;

/**
 * Motion logo: plays on every home page visit after a short delay.
 */
export default function HomeHeroLogo() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;
    video.pause();

    const timer = window.setTimeout(() => {
      video.play().catch(() => {});
    }, PLAY_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, []);

  const wrapClass =
    'w-[min(300px,100%)] max-w-full pointer-events-none select-none [&_video]:pointer-events-none';
  const mediaClass = 'w-full h-auto block';

  return (
    <div className={wrapClass} aria-hidden="true">
      <video
        ref={videoRef}
        src={LOGO_VIDEO_SRC}
        className={mediaClass}
        width={300}
        height={300}
        muted
        playsInline
        preload="auto"
        disablePictureInPicture
        controls={false}
        controlsList="nodownload nofullscreen noremoteplayback"
        onContextMenu={(e) => e.preventDefault()}
        tabIndex={-1}
        aria-label="Hangar X Daily"
      />
    </div>
  );
}
